import produce from "immer";
import ISettingsReducer from "models/ISettingsReducer";
import { actionTypes } from "./actions";

const initialState: ISettingsReducer = {
  isLoading: false,
  isLoaded: false,
  subscriptions: null,
  accountId: null,
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_ACCOUNT_SUCCESS:
        draftState.accountId = action.payload;
        break;
      case actionTypes.GET_ACCOUNT_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_SUBSCRIPTIONS_SUCCESS:
        draftState.subscriptions = action.payload;
        break;
      case actionTypes.GET_SUBSCRIPTIONS_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.SET_SUBSCRIPTIONS_SUCCESS:
        draftState.subscriptions = action.payload;
        break;
      case actionTypes.SET_SUBSCRIPTIONS_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
